import { studio } from "@/lib/studioApi";

const supported = () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const standalone = () => window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;

const toBytes = (value) => {
  const padded = value + "=".repeat((4 - (value.length % 4)) % 4);
  const raw = atob(padded.replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupport = () => {
  if (!supported()) return isIos() && !standalone() ? "ios_install" : "unsupported";
  if (Notification.permission === "denied") return "denied";
  return "ok";
};

export const registerSw = () => (supported() ? navigator.serviceWorker.register("/sw.js").catch(() => null) : Promise.resolve(null));

const swReady = () => Promise.race([
  navigator.serviceWorker.ready,
  new Promise((_, reject) => setTimeout(() => reject(new Error("Service worker indisponible.")), 6000)),
]);

export const currentSubscription = async () => {
  if (!supported()) return null;
  const reg = await swReady();
  return reg.pushManager.getSubscription();
};

export const pushStatus = async () => {
  const sub = await currentSubscription().catch(() => null);
  const { data } = await studio.get("/push/status", { params: { endpoint: sub?.endpoint || "" } });
  return { ...data, this_device: Boolean(sub) && data.this_device };
};

export const enablePush = async () => {
  const support = pushSupport();
  if (support === "ios_install") throw new Error("Sur iPhone : Partager → « Sur l'écran d'accueil », puis ouvrez Devisto depuis l'icône.");
  if (support === "unsupported") throw new Error("Ce navigateur ne gère pas les notifications push.");
  if (support === "denied") throw new Error("Notifications bloquées : autorisez-les dans les réglages du navigateur.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Autorisation refusée.");
  await registerSw();
  const reg = await swReady();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await studio.get("/push/public-key");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(data.publicKey) });
  }
  await studio.post("/push/subscribe", { ...sub.toJSON(), device: navigator.userAgent.slice(0, 160) });
  return sub;
};

export const disablePush = async () => {
  const sub = await currentSubscription();
  if (!sub) return;
  await studio.delete("/push/subscribe", { data: { endpoint: sub.endpoint } }).catch(() => {});
  await sub.unsubscribe().catch(() => {});
};
